/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverse complement`)
};

const es_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento inverso`)
};

const de_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reverses Komplement`)
};

const nl_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omgekeerd complement`)
};

const fr_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complément inverse`)
};

const it_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento inverso`)
};

const pt_br2_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento reverso`)
};

const pt_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complemento reverso`)
};

const ja_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逆相補配列`)
};

const zh_revcomp_op_revcomp = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`反向互补`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const revcomp_op_revcomp = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.revcomp_op_revcomp(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("revcomp_op_revcomp", locale)
	if (locale === "en") return en_revcomp_op_revcomp(inputs)
	if (locale === "es") return es_revcomp_op_revcomp(inputs)
	if (locale === "de") return de_revcomp_op_revcomp(inputs)
	if (locale === "nl") return nl_revcomp_op_revcomp(inputs)
	if (locale === "fr") return fr_revcomp_op_revcomp(inputs)
	if (locale === "it") return it_revcomp_op_revcomp(inputs)
	if (locale === "pt-BR") return pt_br2_revcomp_op_revcomp(inputs)
	if (locale === "pt") return pt_revcomp_op_revcomp(inputs)
	if (locale === "ja") return ja_revcomp_op_revcomp(inputs)
	return zh_revcomp_op_revcomp(inputs)
};